import BaseTooltip from 'components/Tooltips/BaseTooltip';
import TextToggle from 'components/UI/TextToggle';
import DeviceMap from '../../../DeviceMap/index.web';
import VideoPlayer from 'features/VMS/features/VideoPlayer/index.web';
import { useState } from 'react';
import {
  clampPanelHeight,
  DragResizeHandle,
  readStoredPanelHeight,
  storePanelHeight,
} from 'utils/layout/panelResize.utils';

const MEDIA_PANEL_HEIGHT_KEY = 'deviceSettings.mediaPanelHeight';

const MediaPanel = ({ device, isMediaOnly, onVideoSelected }) => {
  const [showVideo, setShowVideo] = useState(false);
  const defaultHeight = isMediaOnly ? 480 : 360;
  const [height, setHeight] = useState(() =>
    clampPanelHeight(readStoredPanelHeight(MEDIA_PANEL_HEIGHT_KEY, defaultHeight)),
  );
  const resizePanel = (wantedHeight) => {
    const nextHeight = clampPanelHeight(wantedHeight);
    setHeight(nextHeight);
    storePanelHeight(MEDIA_PANEL_HEIGHT_KEY, nextHeight);
  };

  const hasVideo = device.device_type?.toLowerCase() === 'overwatch vms' || Boolean(device.camera);
  const isDemoDevice = Number(device.is_simulated) === 1;
  const canShowVideo = hasVideo && !isDemoDevice && Boolean(device.id);
  const videoDeviceId = device.camera || device.id;
  const videoFeedUrl = `${process.env.PUBLIC_API_URL}/v2/integrations/device/camera/${encodeURIComponent(videoDeviceId)}/video-stream/index.m3u8`;
  const videoPlayerLabel = `${device.alias || device.name || device.id || 'Device'} camera feed`;
  const mediaToggle = (
    <TextToggle
      options={['Map', 'Video']}
      value={showVideo && canShowVideo}
      parentControlledState
      disabled={isDemoDevice}
      setValue={(value) => {
        setShowVideo(value);
        if (value) onVideoSelected();
      }}
    />
  );

  return (
    <div className="d-flex flex-column">
      <div className="w-100 overflow-hidden rounded-3" style={{ height: `${height}px` }}>
        {showVideo && canShowVideo ? (
          <VideoPlayer src={videoFeedUrl} ariaLabel={videoPlayerLabel} />
        ) : (
          <DeviceMap
            mode="modal"
            disableFilter={true}
            devicesOverride={[device]}
            selectedDeviceOverride={device}
          />
        )}
      </div>

      <DragResizeHandle
        ariaLabel="Resize the map and video panel"
        value={height}
        onChange={resizePanel}
        onReset={() => resizePanel(defaultHeight)}
      />

      {hasVideo && (
        <div className="mt-2">
          {isDemoDevice ? (
            <BaseTooltip
              id="disabled-video-toggle-tooltip"
              text="No VMS devices are linked to the selected Siren/Giant Voice device"
              placement="top"
            >
              <span className="d-block">{mediaToggle}</span>
            </BaseTooltip>
          ) : (
            mediaToggle
          )}
        </div>
      )}
    </div>
  );
};

export default MediaPanel;
